// Lib
import chroma from 'chroma-js';
import { Thunk } from '../../../../../types/reduxTypes';

// Actions
import { getNewElementId } from '../../../../../element/actions/elementActions';
import { addTagToElements } from '../../../../../element/tags/elementTagActions';
import { createTag } from '../../../../../../common/tags/tagActions';

// Types
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { Tag, TagCreationData } from '../../../../../../common/tags/tagTypes';

const createNewTagThunk =
    (tagData: TagCreationData): Thunk<Tag> =>
    (dispatch: Function) => {
        const id = dispatch(getNewElementId());

        const { name, creator, rootBoardIds, color } = tagData;
        const tag = {
            id,
            name,
            rootBoardIds,
            color: color || chroma.random().hex(),
            meta: {
                creator,
                createdTime: Date.now(),
                modifiedTime: Date.now(),
            },
        };

        dispatch(createTag(tag));
        return tag;
    };

export const createAndAddTagToElementsThunk =
    (tagData: TagCreationData, elements: Immutable.List<ImMNElement>): Thunk =>
    (dispatch: Function) => {
        const newTag = dispatch(createNewTagThunk(tagData));
        dispatch(addTagToElements(elements, newTag.id));
    };
